module.exports = __webpack_public_path__ + "img/onboarding-fnrh.c52907b0.svg";